import { GrIconType } from "@jnpmedi/grebob";

export const enum FilterType {
  Text = "TEXT",
  Select = "SELECT",
}

export type FilterValue = {
  label: string;
  value: string;
};

export type FilterCriteria = {
  type: FilterType;
  values: FilterValue[];
};

export type FilterValues = FilterValue[];

export type FilterOption<T> = {
  key: keyof T & string;
  type: FilterType;
  label: string;
  leftIconType?: GrIconType;
  options?: FilterValues;
};

export function convertStringToFilterValues(valueString: string, options: Array<{ label: string; value: string }>): FilterValue[] {
  if (!valueString || !valueString.trim()) {
    return [];
  }

  const values = valueString
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean);

  return values
    .map((value) => {
      const option = options.find((opt) => opt.value === value);
      return option ? { value, label: option.label } : null;
    })
    .filter((item): item is FilterValue => item !== null);
}

export function transformFiltersToQueryParams<T extends Record<string, any>>(filterCriterias: Record<keyof T, FilterCriteria>) {
  return Object.entries(filterCriterias).reduce((acc, [key, criteria]) => {
    const { type, values } = criteria;

    if (!values.length) {
      acc[key] = [];
      return acc;
    }

    if (type === FilterType.Text) {
      acc[key] = values[0].value;
    } else if (type === FilterType.Select) {
      acc[key] = values.map((v) => v.value);
    }

    return acc;
  }, {} as Record<string, string | string[]>);
}
